import { useLocation } from "react-router-dom";
import { useIsMobile } from "../../hooks/useIsMobile";
import MobileSideBar from "./MobileSideBar";
import DesktopSideBar from "./DesktopSideBar";
import { useSideBarData } from "../../hooks/useSidedBarData";

export default function SideBar() {
  const location = useLocation();
  const isMobile = useIsMobile();

  const { filteredGroups, filteredExaminers } = useSideBarData(
    location.pathname
  );

  if (!["/student", "/examiner"].includes(location.pathname)) return null;

  return isMobile ? (
    <MobileSideBar
      pathname={location.pathname}
      filteredGroups={filteredGroups}
      filteredExaminers={filteredExaminers}
    />
  ) : (
    <DesktopSideBar
      pathname={location.pathname}
      filteredGroups={filteredGroups}
      filteredExaminers={filteredExaminers}
    />
  );
}
